import { Check } from "lucide-react";

export const STEPS = ["Confirm", "Route", "Details", "Sign", "Done"];

// Which step a server stage sits on, and the label of step four for
// the chosen route (sign for our paper, send for theirs).
export function stepFor(stage, route) {
  const map = {
    open: 0,
    expired_request: 4,
    commissioned: 1,
    medicys_sow: 2,
    sign_failed: 2,
    signing: 3,
    client_paper: 2,
    client_paper_failed: 2,
    client_paper_submitting: 3,
    signed: 4,
    signed_elsewhere: 4,
    client_signed: 4,
    countersigning: 4,
    countersign_failed: 4,
    client_paper_submitted: 4,
  };
  const idx = map[stage] ?? 0;
  const labels = [...STEPS];
  if (route === "client_paper") labels[3] = "Send";
  return { idx, labels };
}

export function Stepper({ stage, route }) {
  const { idx, labels } = stepFor(stage, route);
  const finished = idx === labels.length - 1;
  return (
    <nav aria-label="Commissioning progress" data-testid="commission-stepper" data-step={idx}>
      <ol className="hidden sm:flex items-center">
        {labels.map((label, i) => {
          const done = i < idx || finished;
          const active = i === idx && !finished;
          return (
            <li key={label} className={`flex items-center ${i < labels.length - 1 ? "flex-1" : ""}`}>
              <div className="flex items-center gap-2.5">
                <span
                  className={`w-7 h-7 rounded-full border flex items-center justify-center font-mono text-[11px] transition-colors ${
                    done
                      ? "bg-[#1B4F8A] border-[#1B4F8A] text-white"
                      : active
                        ? "bg-white border-[#1B4F8A] text-[#1B4F8A] ring-4 ring-[#1B4F8A]/10"
                        : "bg-white border-stone-300 text-stone-400"
                  }`}
                >
                  {done ? <Check className="w-3.5 h-3.5" /> : i + 1}
                </span>
                <span className={`text-sm ${active ? "text-stone-900 font-medium" : done ? "text-stone-600" : "text-stone-400"}`}>{label}</span>
              </div>
              {i < labels.length - 1 && <span className={`flex-1 h-px mx-4 ${i < idx || finished ? "bg-[#1B4F8A]" : "bg-stone-200"}`} />}
            </li>
          );
        })}
      </ol>
      <div className="sm:hidden flex items-center justify-between text-sm">
        <span className="font-mono text-xs tracking-[0.18em] uppercase text-[#1B4F8A]">Step {Math.min(idx + 1, labels.length)} of {labels.length}</span>
        <span className="text-stone-700 font-medium">{labels[idx]}</span>
      </div>
      <div className="sm:hidden mt-2 h-1 rounded-full bg-stone-200 overflow-hidden">
        <div className="h-full bg-[#1B4F8A] transition-[width] duration-500" style={{ width: `${((idx + 1) / labels.length) * 100}%` }} />
      </div>
    </nav>
  );
}
